// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xjytmiglgttbdqvfjnjg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhqeXRtaWdsZ3R0YmRxdmZqbmpnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzcyMjkyNzAsImV4cCI6MjA1MjgwNTI3MH0.xYNnZXv_tOsGwsq5Ie9_ZfqObv7r1ig8m6YjWFQNToQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);